import { render, staticRenderFns } from "./MEventPopup.vue?vue&type=template&id=2432b734&scoped=true"
import script from "./MEventPopup.vue?vue&type=script&lang=js"
export * from "./MEventPopup.vue?vue&type=script&lang=js"
import style0 from "./MEventPopup.vue?vue&type=style&index=0&id=2432b734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432b734",
  null
  
)

export default component.exports